import { useQuery, useMutation, useQueryClient } from 'react-query';
import { api } from '#/apis';

const apiCalls = {};

apiCalls.fetchDepartments = async () => {
    const { data } = await api.get('/departments');

    return data;
};

apiCalls.fetchDepartment = async departmentId => {
    const { data } = await api.get(`/departments/${departmentId}`);

    return data;
};

apiCalls.createDepartment = async payload => {
    const { data } = await api.post('/departments', payload);

    return data;
};

apiCalls.updateDepartment = async (id, payload) => {
    const { data } = await api.put(`/departments/${id}`, payload);

    return data;
};

apiCalls.deleteDepartment = async departmentId => {
    const { data } = await api.delete(`/departments/${departmentId}`);

    return data;
};

export const useDepartment = (departmentId, queryOptions = {}) => useQuery(['department', departmentId], () => apiCalls.fetchDepartment(departmentId), {
    cacheTime: 0,
    ...queryOptions
});

export const useDepartments = (queryOptions = {}) => useQuery('departments', apiCalls.fetchDepartments, queryOptions);

export const useUpdateDepartment = (queryOptions = {}) => {
    const queryClient = useQueryClient();

    return useMutation(({ id, payload }) => apiCalls.updateDepartment(id, payload), {
        onSuccess: () => {
            queryClient.invalidateQueries('departments');
        },
        ...queryOptions
    });
};

export const useCreateDepartment = (queryOptions = {}) => {
    const queryClient = useQueryClient();

    return useMutation(payload => apiCalls.createDepartment(payload), {
        onSuccess: () => {
            queryClient.invalidateQueries('departments');
        },
        ...queryOptions
    });
};

export const useDeleteDepartment = (queryOptions = {}) => {
    const queryClient = useQueryClient();

    return useMutation(departmentId => apiCalls.deleteDepartment(departmentId), {
        onSuccess: () => {
            queryClient.invalidateQueries('departments');
        },
        ...queryOptions
    });
};
